var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#373E55",
    strokeLinecap: "round",
    strokeWidth: 2.6,
    d: "m23.333 8.166-.723 9.924c-.185 2.536-.277 3.803-1.026 4.715-.37.45-.847.831-1.4 1.117-1.119.578-2.616.578-5.61.578-2.997 0-4.496 0-5.615-.58a4.45 4.45 0 0 1-1.4-1.118c-.75-.913-.84-2.183-1.02-4.721l-.706-9.914"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#373E55",
    strokeLinecap: "round",
    strokeWidth: 2.6,
    d: "M3.5 8.167h22.167m-6.09 0-.84-2.347c-.558-1.56-.837-2.339-1.32-2.825a2.5 2.5 0 0 0-.338-.287c-.533-.375-1.173-.375-2.453-.375-1.313 0-1.969 0-2.511.39q-.18.13-.343.3c-.487.505-.76 1.313-1.303 2.93l-.746 2.214"
  })));
};
export default SvgTrash;